import { makeStyles, tokens, Button } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
    gap: '24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
  },
});

export function UnauthorizedPage() {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Access Denied</h1>
      <p style={{ color: tokens.colorNeutralForeground2 }}>
        You don't have permission to access this page.
      </p>
      <Button appearance="primary" onClick={() => window.history.back()}>
        Go Back
      </Button>
    </div>
  );
}
